<template lang="html">
  <div class="inside-section">
    <div class="container">
      <div class="custom-sections">
        <div class="custom-section">
          <div class="custom-section-header clearfix">
            <div class="custom-section-title text-left">
              {{ $tr('actions.calls') }}
            </div>
          </div>

          <div class="content-section">
            <div class="row-block">
              <div class="col-lg-3 col-md-3 col-sm-6 col-xs-6">
                <div class="custom-field">
                  <input type="text" v-model="phone" />
                </div>
              </div>

              <div class="col-lg-3 col-md-3 col-sm-6 col-xs-6">
                <a @click="createCall" class="vcv-button">
                    {{ $tr('actions.create') }}
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'calls-scene',

  components: {},

  methods: {
    createCall () {
      this.$store.dispatch('calls/store', [
        {phone: this.phone}
      ])
    }
  },

  computed: {},

  data () {
    return {
      phone: null
    }
  },

  beforeMount () {}
}
</script>
